/**
 * Created by Omar Alejandro Leonor Avalos on 2017-07-22.
 * Item Filter
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';

class Filters extends Component {
    render() {
        const { title, icon, children, id, count = 0 } = this.props;

        return (
            <div className="panel panel-default" id={`panel_${id}`}>
                <div className="panel-heading">
                    <h4 className="panel-title">
                        <a
                            style={{ cursor: 'pointer' }}
                            data-toggle="collapse"
                            data-target={`#${id}`}
                            className="collapsed"
                        >
                            {icon} {title}
                            {count > 0 && <span className="badge blue pull-right">{count}</span>}
                        </a>
                    </h4>
                </div>
                <div id={id} className="panel-collapse collapse">
                    <div className="panel-body">
                        {children}
                    </div>
                </div>
            </div>
        );
    }
}

Filters.propTypes = {
    id: PropTypes.string.isRequired
};

export default Filters;



// WEBPACK FOOTER //
// ./components/filters/filter.js